<template>
  <div>
    <div class="question-stem">{{question.Question}}</div>
    <div class="num-responses">{{question.responses.length}} responses</div>
    <div class="responses-container">
      <div v-for="(response, index) in question.responses" :key="`${response.CommentID}-${index}`">
        <div class="short-response light-grey">{{response.Comment}}</div>
        <div class="short-response dark-grey"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      responseBackground: "dark-grey"
    };
  },
  methods: {
    toggleResponseBgColor(color) {
      this.responseBackground = color;
    }
  }
};
</script>

<style scoped>
.question-stem {
  font-family: Arial;
  font-size: 1em;
  width: 80%;
  text-align: justify;
  color: #000000;
  margin-bottom: 1em;
  margin-left: 0.5em;
  margin-top: 1em;
  line-height: 1.2;
}
.num-responses {
  font-family: Arial;
  font-size: 0.95em;
  color: #2c557d;
  margin: 0.5em;
}
.responses-container {
  height: 13em;
  overflow-y: scroll;
  width: 80%;
  margin-left: 0.75em;
}
.short-response {
  font-family: Arial, Helvetica, sans-serif;
}
.light-grey {
  background-color: #e8eeef;
  min-height: 1.5em;
  padding: 0.25em;
}
.dark-grey {
  background-color: rgba(44, 85, 125, 0.21);
  height: 0.75em;
}
@media only screen and (min-width: 1200px) {
  .question-stem {
    font-family: Arial;
    font-size: 1.25em;
    width: 80%;
    text-align: justify;
    color: #000000;
    margin-bottom: 0.75em;
    margin-left: 0.5em;
    margin-top: 1em;
    line-height: 1.2;
  }
}
</style>